import {useDebugValue} from 'react';

import {undef} from '../../../utils/undef';
import {showDestinationlessError} from '../../../utils/experiments';

import {useOptions} from './useOptions';

const defaultDestinationOptions = {
    actionLocation: undef,
    allowErrorHighlighting: undef,
    autoProgress: undef,
    filterType: undef,
    googlePlaceApiKey: undef,
    googlePlaceApiUrl: undef,
    hideSelectedFilter: undef,
    highlightMode: undef,
    iconName: 'location',
    id: 'destination',
    matchMode: undef,
    minLength: undef,
    popoverDesktopMaxWidth: undef,
    popoverDesktopMinMarginRight: undef,
    popoverDesktopMinWidth: undef,
    popoverDesktopWidth: undef,
    popoverMaxDisplayCount: undef,
    popoverMaxDisplayCountMobile: undef,
    recentSearchesDisplayMax: undef,
    remotePath: undef,
    retainUserInput: undef,
    showIcon: undef,
    showInlineSuggestion: undef,
    showRecentSearches: undef,
    showResultIcons: undef,
    showResultLabels: undef,
    showSpinner: undef,
    showTrendingSuggestions: undef,
    truncateResultTerms: undef,
    usePopoverAnimation: undef,
    useResultsAnimation: undef
};

function useDestinationOptions(props, abacusStore, formSettings, systemOptions) {
    const {
        destinationOptions: propsDestinationOptions
    } = props;

    const experimentDestinationOptions = {
        allowErrorHighlighting: showDestinationlessError({shouldLogExperiment: false}, abacusStore, formSettings, systemOptions)
    };

    const {
        options: destinationOptions
    } = useOptions(defaultDestinationOptions, experimentDestinationOptions, propsDestinationOptions);

    const result = {
        destinationOptions
    };

    useDebugValue(result);

    return result;
}

export {useDestinationOptions};
